import {
  TABLE_MANAGEMENT_REPORT_PAGE_REQUEST,
  TABLE_MANAGEMENT_REPORT_LIST_REQUEST,
  TABLE_MANAGEMENT_REPORT_ON_CHANGE_OUTLET_IDS,
  TABLE_MANAGEMENT_REPORT_ON_CLICK_ROW,
  TABLE_MANAGEMENT_REPORT_ON_CLICK_CANCEL,
  TABLE_MANAGEMENT_REPORT_CHANGE_STATUS,
  TABLE_MANAGEMENT_REPORT_CHANGE_DATE
} from 'actions/tableManagement/constants'
import {call, put, takeLatest, select} from 'redux-saga/effects'
import {initialize, change} from 'redux-form'

import * as apiOutlets from 'api/outlets'
import * as actTableManagement from 'actions/tableManagement'
import * as apiProfile from 'api/profile'
import * as act from 'actions'
import * as actNotif from 'actions/notifications'
import * as apiTableManagement from 'api/tableManagement'
import {setSelectedOutletIds} from 'actions/actionBar'
import {showPageLoadingSpinner} from 'actions/loadingSpinner'

import { getFilteredDate } from 'api/get-filtered-date'
import moment from 'moment'

export const getBusinessId = state => state.moka.user.business.id
export const getOutletId = state => state.moka.user.outlet_id[0]

function * fillSearch (profile, startDate, endDate, statusIds) {
  let assignedOutletIds = []
  if (profile.outlet_id.length > 1) {
    assignedOutletIds = [profile.outlet_id[0]]
  } else {
    assignedOutletIds = profile.outlet_id
  }
  let data = {
    'outletIds': assignedOutletIds,
    date: {startDate, endDate},
    statusIds
  }
  yield put(initialize('search', data))
}

export function * onReportsChangeOutletIds (request) {
  yield put(actTableManagement.closeReportsRightColumn())
  yield put(actTableManagement.setReports([]))
  yield put(actTableManagement.setReportSummary([]))
  yield put(actTableManagement.setReportDetail(null))
  yield put(showPageLoadingSpinner(true))
  const {payload: {outletIds, statusIds, startDate, endDate}} = request
  try {
    yield put(act.showProgressBar())
    yield call(apiOutlets.patchLogin, {id: outletIds})
    let resProfile = yield call(apiProfile.getProfile)
    yield put(setSelectedOutletIds(outletIds))
    yield put(change('search', 'outletIds', outletIds))
    yield call(fillSearch, resProfile.data, startDate, endDate, statusIds)
    yield call(reportsRequest, { payload: { page: 1, statusIds, startDate, endDate, previousReports: null } })
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
    yield put(showPageLoadingSpinner(false))
  }
}

export function * reportsPageRequestFlow () {
  yield put(showPageLoadingSpinner(true))
  yield put(actTableManagement.setReports([]))
  yield put(actTableManagement.setReportSummary([]))
  yield put(actTableManagement.setReportDetail(null))
  yield put(actTableManagement.closeReportsRightColumn())

  // set up selected status
  let statusIds = 0
  // call date
  let filteredDate = yield call(getFilteredDate)
  let startDate = moment(filteredDate.data.start_date, 'YYYY-MM-DD')
  let endDate = moment(filteredDate.data.end_date, 'YYYY-MM-DD')
  yield put(act.showProgressBar())
  try {
    yield call(reportsRequest, { payload: { page: 1, statusIds: 0, startDate, endDate, previousReports: null } })
    let response = yield call(apiOutlets.outlets)
    yield put(actTableManagement.setOutlets(response.data))
    let resProfile = yield call(apiProfile.getProfile)
    yield call(fillSearch, resProfile.data, startDate, endDate, statusIds)
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
    yield put(showPageLoadingSpinner(false))
  }
}

export function * getTableReports (params) {
  yield put(act.showProgressBar())
  try {
    let outletId = yield select(getOutletId)
    let response = yield call(apiTableManagement.getTableReports, outletId, params)
    return response.data
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
    yield put(showPageLoadingSpinner(false))
  }
}

export function * reportsRequest (request) {
  const PAGE_SIZE = 50
  const { page, previousReports } = request.payload
  let statusIds, startDate, endDate
  statusIds = parseInt(request.payload.statusIds)
  startDate = request.payload.startDate.format('YYYY-MM-DD 00:00:00')
  endDate = request.payload.endDate.format('YYYY-MM-DD 23:59:59')
  let query = {
    dineInOnly: true,
    size: PAGE_SIZE,
    page: page,
    startDate,
    endDate
  }
  if (statusIds === 0) {
    query.statuses = 'COMPLETE,CANCELLED'
  } else if (statusIds === 1) {
    query.status = 'COMPLETE'
  } else if (statusIds === 2) {
    query.status = 'CANCELLED'
  }
  yield put(act.showProgressBar())

  let summary = {
    total_items: 0,
    total_pages: 0,
    cancelled: 0,
    completed: 0
  }
  try {
    let outletId = yield select(getOutletId)
    let rv = yield call(apiTableManagement.getTableReportSummary, outletId, query)
    let {cancelledCount, completedCount} = rv.data
    summary.cancelled = cancelledCount
    summary.completed = completedCount
    summary.total_items = cancelledCount + completedCount
    summary.total_pages = Math.ceil(summary.total_items / PAGE_SIZE)
  } catch (error) {
    yield put(actNotif.error(error.message))
    return false
  } finally {
  }

  try {
    let reports
    let reportsResponse = yield call(getTableReports, query)
    if (previousReports) {
      reports = previousReports.concat(reportsResponse)
    } else {
      reports = reportsResponse
    }
    yield put(actTableManagement.setReports(reports))
    yield put(actTableManagement.setReportSummary(summary))
    yield put(actTableManagement.setReportsTotalPage(summary.total_pages))
    yield put(actTableManagement.setReportsCurrentPage(page))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
  }
  yield put(showPageLoadingSpinner(false))
}

export function * clickCancel () {
  yield put(actTableManagement.setReportDetail(null))
  yield put(actTableManagement.closeReportsRightColumn())
}

export function * clickReportRow (request) {
  let {payload: {report}} = request
  try {
    yield put(actTableManagement.setReportDetail(null))
    yield put(act.showProgressBar())
    let outletId = yield select(getOutletId)
    const reportDetailRes = yield call(apiTableManagement.getTableReport, report.id, outletId, {})
    const {data: reportDetail} = reportDetailRes
    yield put(actTableManagement.setReportDetail(reportDetail))
    yield put(actTableManagement.setMustScrollTop(true))
    yield put(actTableManagement.openReportsRightColumn())
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
    yield put(actTableManagement.setMustScrollTop(false))
  }
}

export function * changeReportDateFlow (request) {
  yield put(actTableManagement.closeReportsRightColumn())
  yield put(actTableManagement.setReports([]))
  yield put(actTableManagement.setReportSummary([]))
  yield put(actTableManagement.setReportDetail(null))
  yield put(showPageLoadingSpinner(true))
  const {payload: {outletIds, statusIds, startDate, endDate}} = request
  try {
    yield put(act.showProgressBar())
    let profile = {
      outlet_id: []
    }
    profile.outlet_id.push(outletIds[0])
    yield call(fillSearch, profile, startDate, endDate, statusIds)
    yield call(reportsRequest, { payload: { page: 1, statusIds, startDate, endDate, previousReports: null } })
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
    yield put(showPageLoadingSpinner(false))
  }
}

function * changeStatusFlow (request) {
  yield put(actTableManagement.closeReportsRightColumn())
  yield put(actTableManagement.setReports([]))
  yield put(actTableManagement.setReportSummary([]))
  yield put(actTableManagement.setReportDetail(null))
  yield put(showPageLoadingSpinner(true))
  const {payload: {outletIds, statusIds, startDate, endDate}} = request
  try {
    yield put(act.showProgressBar())
    let profile = {
      outlet_id: []
    }
    profile.outlet_id.push(outletIds[0])
    yield call(fillSearch, profile, startDate, endDate, statusIds)
    yield call(reportsRequest, { payload: { page: 1, statusIds, startDate, endDate, previousReports: null } })
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
    yield put(showPageLoadingSpinner(false))
  }
}

export default function * tableManagementReportSaga () {
  yield takeLatest(TABLE_MANAGEMENT_REPORT_LIST_REQUEST, reportsRequest)
  yield takeLatest(TABLE_MANAGEMENT_REPORT_PAGE_REQUEST, reportsPageRequestFlow)
  yield takeLatest(TABLE_MANAGEMENT_REPORT_ON_CHANGE_OUTLET_IDS, onReportsChangeOutletIds)
  yield takeLatest(TABLE_MANAGEMENT_REPORT_ON_CLICK_ROW, clickReportRow)
  yield takeLatest(TABLE_MANAGEMENT_REPORT_ON_CLICK_CANCEL, clickCancel)
  yield takeLatest(TABLE_MANAGEMENT_REPORT_CHANGE_DATE, changeReportDateFlow)
  yield takeLatest(TABLE_MANAGEMENT_REPORT_CHANGE_STATUS, changeStatusFlow)
}



// WEBPACK FOOTER //
// ./app/sagas/tableManagement/report.js